import React, { useState } from 'react';
import { useQuery } from 'react-query';

const Modal2 = ({ data }) => {
    const [reviewtextarea, setreviewtextarea] = useState("")

    const handleAddReview = () => {
        const review = { review: reviewtextarea, productName: data?.Engine, email: data?.email, id: data?._id }
        fetch("https://drab-erin-dove-suit.cyclic.app/review",
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: "PUT",
                body: JSON.stringify(review)
            })
            .then(res => res.json())
            .then(data => console.log(data))

    }
    return (
        <div>
            <input type="checkbox" id="review-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box">
                    <h3 className="font-bold text-lg">Review for {data.Engine}</h3>
                    {/* <textarea className="textarea textarea-primary  " placeholder="Bio"></textarea>                 */}
                    <textarea name="" id="" cols="60" rows="8" className="textarea textarea-ghost " placeholder='Write Your Review' onChange={(e) => setreviewtextarea(e.target.value)}></textarea>
                    <div className="modal-action">
                        <label htmlFor="review-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                        <label htmlFor="review-modal" className='btn btn-primary' onClick={() => handleAddReview()} className="btn">Yay!</label>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Modal2;